import React, { useState, useEffect } from "react";
import useStore from "../store/useStore";
import ButtonOrang from "../components/ButtonOrang";

export default function VideoBackground({
  video,
  titulo1,
  titulo2,
  textbutton,
  link,
  logo,
  cartel,
  onButtonClick,
}) {
  const setVideoUrlError = useStore((state) => state.setVideoUrlError);
  const videoPlaceholder = useStore((state) => state.videoPlaceholder);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [videoError, setVideoError] = useState(false);

  // ✅ Control de placeholder progresivo
  const [placeholderSrc, setPlaceholderSrc] = useState("/fallback.jpg");

  useEffect(() => {
    if (videoPlaceholder) {
      const img = new Image();
      img.src = videoPlaceholder;
      img.onload = () => {
        setPlaceholderSrc(videoPlaceholder);
      };
    }
  }, [videoPlaceholder]);

  return (
    <div className="relative w-full h-[800px] mt-[60px] md:mt-0 overflow-hidden flex items-center p-2 justify-start">
      {/* ✅ Imagen placeholder progresiva */}
      {(!videoLoaded || videoError) && (
        <img
          src={placeholderSrc}
          alt="Cargando video"
          className="absolute top-0 left-0 w-full h-full object-cover z-0 transition-opacity duration-500"
        />
      )}

      {/* 🎥 Video de fondo */}
      {!videoError && (
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          playsInline
          muted
          onCanPlay={() => setVideoLoaded(true)}
          onLoadedData={() => setVideoLoaded(true)}
          onError={() => {
            setVideoUrlError("No se pudo cargar el video");
            setVideoError(true);
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
      )}

      {/* Gradiente superpuesto */}
      <div className="absolute top-0 left-0 w-full h-full z-[1] pointer-events-none bg-gradient-to-t from-sidom-orange to-transparent to-30%" />

      {/* Contenido */}
      <div className="absolute w-full z-10 px-1">
        <div className="flex container flex-col lg:flex-row justify-center items-center gap-10 md:gap-20 lg:gap-32 xl:gap-48 max-w-screen-xl mx-auto">
          {/* Texto */}
          <div className="w-full lg:w-1/2 text-left leading-[1.3]">
            <h1 className="text-sidom-light text-wrap text-4xl md:text-6xl lg:text-5xl xl:text-6xl font-bold mb-4">
              {titulo1}
            </h1>
            <p className="text-sidom-light text-2xl mb-8">{titulo2}</p>
            {cartel && cartel}
            <div className="mb-10 md:mb-0">
              <ButtonOrang
                text={textbutton}
                background="bg-sidom-orange"
                textColor="text-sidom-light"
                bloke={true}
                onClick={onButtonClick}
                link={link}
              />
            </div>
          </div>

          {/* Imagen decorativa */}
          <div className="relative flex justify-center items-center w-full lg:w-1/2 z-10">
            {videoLoaded && (
              <img
                src={logo}
                alt="Imagen de fondo"
                className="w-[220px] sm:w-[260px] md:w-[280px] lg:w-[300px] animate-float"
                loading="lazy"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
